import Language_EnglishUrl from "../../../assets/translations/en.json";
import Language_NorwegianUrl from "../../../assets/translations/no.json";

export const urls = {
    en: Language_EnglishUrl,
    no: Language_NorwegianUrl
};

export const DOWNLOADING_LOCALIZATION = "DOWNLOADING_LOCALIZATION";

export const DOWNLOADED_LOCALIZATION = "DOWNLOADED_LOCALIZATION";

export const FAILED_TO_DOWNLOAD_LOCALIZATION = "FAILED_TO_DOWNLOAD_LOCALIZATION";

export const downloadedLocalization = (data) => ({
    type: DOWNLOADED_LOCALIZATION,
    data
});

export const failedToDownloadLocalization = () => ({
    type: FAILED_TO_DOWNLOAD_LOCALIZATION
});

export const downloadingLocalization = () => ({
    type: DOWNLOADING_LOCALIZATION
});

